/**
 * Search and AI crawlers that run our JavaScript when they render a page.
 *
 * Search Console's crawl stats (2026-10-13): of 1.08 M Google crawl
 * requests in three months, 558 k were Next.js link prefetches
 * (`?_rsc=` payloads for every link on a rendered page) and 124 k were
 * our own tracking beacons, against ~260 k page fetches; 79.5 k listing
 * pages sat "discovered, not indexed". A crawler needs neither: it reads
 * the server HTML and finds links in it. So for crawler user agents the
 * page makes no prefetches (CRAWLER_QUIET_SCRIPT, inlined in <head>) and
 * sends no tracking (lib/tracking). People are unaffected.
 */
export const CRAWLER_UA_SOURCE =
  "Googlebot|Google-InspectionTool|AdsBot-Google|Mediapartners-Google|Storebot-Google|bingbot|BingPreview|YandexBot|Applebot|DuckDuckBot|Baiduspider|GPTBot|OAI-SearchBot|ChatGPT-User|PerplexityBot|ClaudeBot|Claude-User|Amazonbot|facebookexternalhit";

export const IS_CRAWLER =
  typeof navigator !== "undefined" && new RegExp(CRAWLER_UA_SOURCE, "i").test(navigator.userAgent);

/** Runs before the app's scripts: for a crawler, every `?_rsc=` fetch
 *  (link prefetches; a crawler never navigates client-side) fails at
 *  once, and Next treats a failed prefetch as a no-op. */
export const CRAWLER_QUIET_SCRIPT = `(function(){try{if(!new RegExp(${JSON.stringify(CRAWLER_UA_SOURCE)},"i").test(navigator.userAgent))return;var f=window.fetch;window.fetch=function(i,o){var u=typeof i==="string"?i:(i&&i.url)||String(i);if(u.indexOf("_rsc=")!==-1)return Promise.reject(new TypeError("no prefetch for crawlers"));return f.apply(this,arguments)}}catch(e){}})();`;
